<div class="lg:p-6 w-full relative" *ngIf="!['', null, undefined].includes(listGalleryItems);else loading">
    <div class="w-full flex md:justify-between justify-start p-4 lg:p-0 items-center">
        <div class="flex items-center">
            <i class="ico-ArrowRight cursor-pointer lg:hidden block ml-3 text-xl" (click)="closeModal()"></i>
            <i class="ico-Close cursor-pointer lg:block hidden text-xl" (click)="closeModal()"></i>
            <h3 class="text-base mx-2">{{'تصاویر ' + modalData?.Name}}</h3>
        </div>
        <button *ngIf="showSlider" (click)="showSlider = false" mat-button color="primary"
            class="text-blue-500 !font-normal text-sm flex items-center icon-arrow-button">
            <span class="!font-normal text-sm">برگشت به گالری</span>
            <i class="ico-Left !text-2xl text-blue-500"></i>
        </button>
    </div>
    <ul *ngIf="!showSlider"
        class="flex bg-white !sticky top-0 pt-3 lg:pt-0  mt-3 overflow-x-auto x-scroll px-4 lg:px-0">
        <li class="border border-solid rounded-3xl whitespace-nowrap p-2 mb-2 ml-2 cursor-pointer "
            (click)="filterItem(item,$event)" [class.bg-blue-500]="item.active"
            *ngFor="let item of filterItemsGallery;let index = index">
            <span class="text-sm  {{item.active ? 'text-white' : 'text-gray-600'}}"> {{item.Name}}
                ({{item.Count}})</span>
        </li>
    </ul>
    <div
        class="w-full grid lg:grid-cols-3 grid-cols-1 lg:gap-4 lg:h-[59vh] lg:min-h-[535px] px-4 lg:pr-0 h-full lg:overflow-y-auto {{showSlider ? 'hidden' : 'block'}}">


        <div class="img-main mb-3 lg:mb-0" *ngFor="let item of listGalleryItems; let index = index">
            <!-- <iho-skeleton height="260px" width="100%" *ngIf="item.isLoading"></iho-skeleton> -->
            <img [ngSrc]="item.Webp" height="260" width="390" [loading]="'lazy'"
            (error)="item.Webp = cdnUrl + '/images/no-image.jpg'"
                class="lg:rounded-lg cursor-pointer h-[260px] md:h-[300px] lg:w-[390px] w-full object-cover"
                [alt]="item.Alt" (click)="navigatorVal ? showSlideTo(index) : ''">
        </div>



    </div>

    <div class="w-full lg:h-[59vh] lg:min-h-[535px] h-[200px] mt-7 {{showSlider ? 'block' : 'hidden'}}"
        [class.phone]="!navigatorVal">
        <ng-container *ngIf="resetSwiper()">
        <swiper [config]="configSwiperGallery" (slideChange)="onSlideChange($event)" #swiperGalleryEl>
            <ng-template swiperSlide *ngFor="let item of listGalleryItems" class="lg:h-[60vh] h-[200px] md:h-[400px]">
                <img [ngSrc]="item.Jpg" height="300" width="390" [loading]="'eager'"
                    (error)="item.Jpg = cdnUrl + '/images/no-image.jpg'" class="rounded-lg cursor-pointer w-full h-full"
                    [alt]="item.Alt">
            </ng-template>
        </swiper>
        <div class="flex float-start border  border-solid rounded-full px-1 mx-2 cursor-pointer swiper-btn-prev"
            [ngClass]="showArrowPrev ? 'active:bg-blue-500 active:text-white' : 'opacity-50 cursor-default'"
            (click)="previousSlide()">
            <i class="ico-Right text-3xl"></i>
        </div>
        <div class="flex float-start border  border-solid rounded-full px-1 cursor-pointer swiper-btn-next"
            [ngClass]="showArrowNext ? 'active:bg-blue-500 active:text-white' : 'opacity-50 cursor-default'"
            (click)="nextSlide()">
            <i class="ico-Left text-3xl"></i>
        </div>
        </ng-container>
    </div>
</div>






<ng-template #loading>
    <div class="w-full h-full flex justify-center items-center">
        <iho-loading></iho-loading>
    </div>

</ng-template>